import { Component } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomCmsItemComponentData } from '../custom-cms-item/custom-cms-item.model';
import { CustomMoreInfoModel } from './custom-more-info.model';

@Component({
  selector: 'app-custom-more-info',
  templateUrl: './custom-more-info.component.html',
  styleUrls: ['./custom-more-info.component.scss'],
  standalone: false
})
export class CustomMoreInfoComponent {
  componentData$: Observable<CustomMoreInfoModel> = this.componentData.data$;
  items$: Observable<Observable<CustomCmsItemComponentData>[]> = this.componentData$.pipe(
    map((data) => {
      if (data.items) {
        return data.items.trim().split(' ');
      }
    }),
    map((uids) => {
      if (uids) {
        return uids.map((uid) => this.cmsService.getComponentData(uid));
      }
    })
  );

  constructor(
    private componentData: CmsComponentData<CustomMoreInfoModel>,
    private cmsService: CmsService
  ) { }
}
